const googleMapInit = () => {
    const maps = Array.from(document.querySelectorAll('.bn-google-map'));

    function initMap(el) {
        const styles = [
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#444444"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.business",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi.business",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi.business",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "hue": "#ff0000"
                    }
                ]
            },
            {
                "featureType": "poi.business",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#42b311"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            }
        ];
    
        const markers = el.querySelectorAll('.marker');
    
        const mapArgs = {
            zoom: el.dataset.zoom || 16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: styles,
            disableDefaultUI: true,
        };
        const map = new google.maps.Map(el, mapArgs);
    
        map.markers = [];
        markers.forEach(function (marker) {
            initMarker(marker, map);
        });
    
        centerMap(map);
    
        return map;
    }
    
    /**
     * initMarker
     *
     * Creates a marker for the given element and map.
     *
     * @param   HTMLElement marker The marker element.
     * @param   object map The map instance.
     * @return  object The marker instance.
     */
    function initMarker(marker, map) {
        // Get position from marker.
        const lat = parseFloat(marker.dataset.lat.replace(',', '.'));
        const lng = parseFloat(marker.dataset.lng.replace(',', '.'));
    
        const latLng = { lat: lat, lng: lng };
    
        const markerSetting = {
            position: latLng,
            map: map,
        };
    
        if (marker.dataset.icon) {
            markerSetting.icon = marker.dataset.icon;
        }
    
        const googleMarker = new google.maps.Marker(markerSetting);
    
        map.markers.push(googleMarker);
    
        // If marker contains HTML, add it to an infoWindow.
        if (marker.innerHTML.trim()) {
            // Create info window.
            const infowindow = new google.maps.InfoWindow({
                content: marker.innerHTML,
            });
    
            // Show info window when marker is clicked.
            googleMarker.addListener('click', function () {
                infowindow.open(map, googleMarker);
            });
        }
    }
    
    /**
     * Centers the map showing all markers in view.
     *
     * @param   object map The map instance.
     * @return  void
     */
    function centerMap(map) {
        const bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function (marker) {
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng(),
            });
        });
    
        if (map.markers.length === 1) {
            map.setCenter(bounds.getCenter());
        } else {
            map.fitBounds(bounds);
        }
    }

    if (maps) {
        maps.forEach(map => {
            initMap(map);
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        googleMapInit();
});

